import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import transform from "../../utils/jsonpath-object-transform";
import { Helmet } from "react-helmet";
import { getCategoryById, getSubCategories, getTopicById, getTopicsByCategoryId } from "../../utils/userManual";
import { generateReactKey } from "../../utils/reactKey";
import { toLowerCaseHyphenated } from "../../utils/siteUtils";
import useUserManual from "../../hooks/useUserManual";
import UserManualContext from "./context";
import Heading from "../../elements/heading";
import IconLink from "../../elements/icon-link";
import ListContent from "../../components/ListContent";
import "./style.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { setDynamicBreadcrumbList } from "../../redux/actions/actions";
import { scrollToSmooth } from "../../hooks/scrollToSmooth.js";
import { PrimaryLink } from "../../elements";
import ServerError from "../../sections/server-error";
import { canUseDOM } from "../../utils";
import { xml2json, parseXml } from "../../utils/xml2json";
import { Carousel } from "react-responsive-carousel";
const NEW_UI_2020 = "category:UI_New_2020";

const UserManual = props => {
  const getBaseURL = model => {
    if (!model) return null;
    let baseURL = null;
    fields.carModelListContent.fields.items.forEach((listItem, index) => {
      if (!listItem?.fields?.CTA[0]?.fields?.link?.value?.title) return null;

      if (toLowerCaseHyphenated(listItem?.fields?.CTA[0]?.fields?.link?.value?.title || listItem.fields?.CTA[0]?.fields?.link?.value?.text) === toLowerCaseHyphenated(model)) {
        baseURL = listItem.fields?.CTA[0]?.fields?.link?.value?.href;
      }
    });
    return baseURL;
  };

  const { rendering, fields, match, history, setDynamicBreadcrumbList } = props;

  const [route, setRoute] = useState({
    model: match.params.model,
    category: match.params.category,
    topic: match.params.topic
  });
  if (route.model) match.params.model = route.model;
  if (route.category) match.params.category = route.category;
  if (route.topic) match.params.topic = route.topic;
  const [currentModel, setCurrentModel] = useState();
  const baseURL = route.model && canUseDOM() ? getBaseURL(route.model) : null;
  const { ...data } = useUserManual(baseURL);

  const scrollToTop = () => {
    let topElement = canUseDOM() && window.document.getElementById("root");
    scrollToSmooth(topElement);
  };

  useEffect(() => {
    if (route.model && !route.category && !route.topic) {
      window && window.history.pushState(null, null, `/${match.params.lang}/${match.params.sitecoreRoute}/----${route.model}`);
    }
    if (route.model && route.category && !route.topic) {
      window && window.history.pushState(null, null, `/${match.params.lang}/${match.params.sitecoreRoute}/----${route.model}/${route.category}`);
    }
    if (route.model && route.category && route.topic) {
      window && window.history.pushState(null, null, `/${match.params.lang}/${match.params.sitecoreRoute}/----${route.model}/${route.category}/${route.topic}`);
    }
    if (route.model && canUseDOM()) {
      /** Get the name of the current car model from the list item heading */
      let carOptions = fields.carModelListContent?.fields?.items.map(listItem => {
        return listItem?.fields.CTA.map(button => {
          return toLowerCaseHyphenated(button?.fields?.link?.value?.title || button?.fields?.link?.value?.text);
        })[0];
      });

      const indexOfCurrentCarModel = carOptions.indexOf(route.model);

      let heading = fields.carModelListContent?.fields?.items[indexOfCurrentCarModel]?.fields?.headingBody?.value;

      // remove the styling from the list content
      var node = document.createElement("div");
      node.innerHTML = heading;
      heading = node.innerText;

      setCurrentModel(heading);
    }
  }, [route]);

  useEffect(() => {
    if (route.model && !route.category && !route.topic) {
      // update breadcrumbs
      let breadCrumbNode = {
        breadcrumbName: currentModel
      };
      setDynamicBreadcrumbList([breadCrumbNode]);
    }
  }, [currentModel, route.category, route.topic]);

  useEffect(() => {
    return function cleanup() {
      setDynamicBreadcrumbList(null);
    };
  }, []);

  const setRouteFromWindowLocation = () => {
    const arrParams = window.location.href && window.location.href.split("/----").length > 1 ? window.location.href.split("/----")[1].split("/") : [];
    const params = {
      model: arrParams?.length ? arrParams[0] : undefined,
      category: arrParams?.length > 1 ? arrParams[1] : undefined,
      topic: arrParams?.length > 2 ? (arrParams[2].split("#").length > 1 ? arrParams[2].split("#")[1] : arrParams[2].split("#")[0]) : undefined
    };
    setRoute(params);
  };

  useEffect(() => {
    window.addEventListener("popstate", setRouteFromWindowLocation);
    return () => window.removeEventListener("popstate", setRouteFromWindowLocation);
  }, []);

  const onRouteChanged = params => {
    setRoute({ ...route, ...params });
  };

  fields.carModelListContent = fields.carModelListContent?.fields
    ? {
        ...fields.carModelListContent,
        fields: {
          ...fields.carModelListContent?.fields,
          items: fields.carModelListContent?.fields?.items.map(item => ({
            ...item,
            fields: {
              ...item?.fields,
              CTA: item?.fields?.CTA.map(item1 => ({
                ...item1,
                fields: {
                  ...item1?.fields,
                  callback: () => {
                    const modelRoute = toLowerCaseHyphenated(item1?.fields?.link?.value?.title || item1?.fields?.link?.value?.text);
                    setRoute({ model: modelRoute });
                  }
                }
              }))
            }
          }))
        }
      }
    : null;

  if (baseURL)
    return (
      <UserManualContext.Provider value={{ ...data, setDynamicBreadcrumbList, currentModel, scrollToTop, getBaseURL }}>
        <div className="user-manual ">
          {route.model && !route.category && !route.topic && <Categories {...{ fields, match, baseURL, onRouteChanged }} />}
          {route.category && route.category !== NEW_UI_2020 && !route.topic && <CategoryTopics {...{ fields, match, baseURL, onRouteChanged }} />}

          {route.category && route.topic && <Topic {...{ fields, match, baseURL, history, onRouteChanged }} />}
        </div>
      </UserManualContext.Provider>
    );
  else return <>{fields.carModelListContent && <ListContent {...{ ...fields.carModelListContent, rendering: { datasourceid: `${rendering.datasourceid}-list-content` } }}></ListContent>}</>;
};

const Categories = ({ fields, match, onRouteChanged }) => {
  const [route, setRoute] = useState({
    model: match.params.model,
    category: match.params.category,
    topic: match.params.topic
  });
  const { categories, parentCategories, currentModel, getBaseURL } = useContext(UserManualContext);
  const iconsEndpoint = getBaseURL(match?.params?.model)?.replace("/manifest.json", "");

  const data = {
    categories: categories,
    parentCategories: parentCategories,
    currentModel: currentModel
  };

  const structuredData = fields.categoriesMapping.value && data ? transform(data, JSON.parse(fields.categoriesMapping.value)) : null;

  return (
    <div className="grid">
      {structuredData && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </Helmet>
      )}
      <div className="topic-page-header grid" style={{ backgroundImage: `url("${fields?.categoriesHeroBackgroundImage?.value?.src}")` }}>
        {fields.articleOverline.value && <p className="overline">{fields.categoriesOverline?.value || ""}</p>}

        <Heading
          {...{
            html: { value: `<span>${currentModel}</span>` },
            type: { fields: { phrase: { value: "h1" } } },
            typographyClass: "type-h1"
          }}
        />
      </div>
      <div className="categories">
        {parentCategories
          .sort((a, b) => parseFloat(a.sort_rank) - parseFloat(b.sort_rank))
          .map(({ id, title, icon }) => {
            return (
              <div className="category" key={generateReactKey()}>
                <IconLink
                  {...{
                    iconName: icon ? { value: { src: `${iconsEndpoint}/${icon}`, useAsIcon: true } } : null,
                    link: {
                      value: {
                        text: title,
                        href: `/${match.params.lang}/${match.params.sitecoreRoute}/----${route.model}/${id}`
                      }
                    },
                    callback: e => {
                      onRouteChanged({ model: route.model, category: id, topic: undefined });
                    }
                  }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

const CategoryTopics = ({ fields, match, onRouteChanged }) => {
  const { category } = match.params;
  const { topics, categories, setDynamicBreadcrumbList, currentModel, scrollToTop, id, getBaseURL } = useContext(UserManualContext);
  const activeCategory = getCategoryById(categories, category);
  const categoryTopics = getTopicsByCategoryId(topics, category);
  const iconsEndpoint = getBaseURL(match?.params?.model)?.replace("/manifest.json", "");

  let parentUrl;
  let buttonText;

  if (canUseDOM()) {
    const parentToCategory = categories.find(c => c.id === activeCategory.parent_categories[0]);

    if (activeCategory?.parent_categories.includes(NEW_UI_2020)) {
      parentUrl = `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}`;
      buttonText = `${fields.topicsBackCTALabel.value.replace(/\{0\}/, currentModel)}`;
    } else {
      parentUrl = `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}/${activeCategory?.parent_categories[0]}`;
      buttonText = `${fields.topicsBackCTALabel.value.replace(/\{0\}/, parentToCategory?.title)}`;
    }
  }

  const [routeParams, setRouteParams] = useState(
    activeCategory?.parent_categories?.length > 0 && !activeCategory?.parent_categories.includes(NEW_UI_2020)
      ? {
          model: match.params.model,
          category: activeCategory?.parent_categories[0],
          topic: undefined
        }
      : {
          model: match.params.model,
          category: undefined,
          topic: undefined
        }
  );

  const backCTA = {
    iconName: fields?.articleBackIcon,
    colorScheme: {
      fields: {
        phrase: {
          value: "green"
        }
      }
    },
    link: { value: { href: parentUrl } },
    buttonText: buttonText,
    callback: () => {
      onRouteChanged(routeParams);
    }
  };

  useEffect(() => {
    if (!canUseDOM()) {
      return;
    }

    if (activeCategory?.parent_categories?.length > 0 && !activeCategory?.parent_categories.includes(NEW_UI_2020)) {
      setRouteParams({
        model: match.params.model,
        category: activeCategory?.parent_categories[0],
        topic: undefined
      });
    } else {
      setRouteParams({
        model: match.params.model,
        category: undefined,
        topic: undefined
      });
    }

    /*** fix breadcrumb */
    let breadCrumbNode1 = {
      breadcrumbName: currentModel,
      url: `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}`
    };
    let breadCrumbNode2 = {
      breadcrumbName: activeCategory?.title
    };
    setDynamicBreadcrumbList([breadCrumbNode1, breadCrumbNode2]);
    scrollToTop();
  }, [category, activeCategory]);

  const data = {
    topics: topics,
    categories: categories,
    currentModel: currentModel,
    activeCategory: activeCategory,
    categoryTopics: categoryTopics,
    id: id
  };
  const structuredData = fields.categoryTopicsMapping.value && data ? transform(data, JSON.parse(fields.categoryTopicsMapping.value)) : null;

  const subCategories = getSubCategories(categories, category);

  return (
    <div className="grid">
      {structuredData && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </Helmet>
      )}
      <div className="topic-page-header grid" style={{ backgroundImage: `url("${fields?.topicsHeroBackgroundImage?.value?.src}")` }}>
        {fields.articleOverline.value && <p className="overline">{fields.topicsOverline?.value || ""}</p>}

        <Heading
          {...{
            html: { value: `<span>${activeCategory?.title || ""}</span>` },
            type: { fields: { phrase: { value: "h1" } } },
            typographyClass: "type-h1"
          }}
        />

        {fields?.topicsBackCTALabel?.value && <IconLink {...backCTA} />}
      </div>

      <div className="topics">
        {subCategories.length > 0 && (
          <div className="topics-section">
            {fields.topicsHeadingBody.value && (
              <Heading
                {...{
                  html: fields.topicsHeadingBody,
                  type: fields.topicsHeadingType,
                  typographyClass: "type-h2"
                }}
              />
            )}
            <ul>
              {subCategories
                .sort((a, b) => parseFloat(a.sort_rank) - parseFloat(b.sort_rank))
                .map(({ id, title, icon }) => (
                  <li key={id}>
                    <IconLink
                      {...{
                        iconName: icon ? { value: { src: `${iconsEndpoint}/${icon}`, useAsIcon: true } } : null,
                        link: {
                          value: {
                            text: title,
                            href: `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}/${id}`
                          }
                        },
                        callback: () => {
                          onRouteChanged({ model: match.params.model, category: id, topic: undefined });
                        }
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>
        )}
        {categoryTopics.length > 0 && (
          <div className="articels-section">
            {fields.articlesHeadingBody.value && (
              <Heading
                {...{
                  html: fields.articlesHeadingBody,
                  type: fields.articlesHeadingType,
                  typographyClass: "type-h2"
                }}
              />
            )}
            <ul>
              {categoryTopics
                .sort((a, b) => parseFloat(a.sort_rank) - parseFloat(b.sort_rank))
                .map(({ id, title, icon }) => (
                  <li key={generateReactKey()}>
                    <PrimaryLink
                      {...{
                        iconName: icon ? { value: { src: `${iconsEndpoint}/${icon}`, useAsIcon: true } } : fields.defaultLinkIcon,
                        colorScheme: {
                          fields: {
                            phrase: {
                              value: "white"
                            },
                            key: {
                              value: "white"
                            }
                          }
                        },
                        link: {
                          value: {
                            text: title,
                            href: `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}/${category}/${id}`
                          }
                        },
                        callback: () => {
                          onRouteChanged({ model: match.params.model, category: category, topic: id });
                        }
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

const Topic = ({ fields, match, history, onRouteChanged }) => {
  const { category, topic } = match.params;
  const { topics, categories, setDynamicBreadcrumbList, currentModel, scrollToTop } = useContext(UserManualContext);
  const activeCategory = getCategoryById(categories, category);
  const activeTopic = getTopicById(topics, topic);
  const backCTA = {
    iconName: fields?.articleBackIcon,
    colorScheme: {
      fields: {
        phrase: {
          value: "green"
        }
      }
    },
    link: { value: { href: `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}/${category}` } },
    buttonText: `${fields.articleBackCTALabel.value.replace(/\{0\}/, activeCategory?.title)}`,
    callback: () => {
      onRouteChanged({
        model: match.params.model,
        category: category,
        topic: undefined
      });
    }
  };

  useEffect(() => {
    if (!canUseDOM()) {
      return;
    }
    /*** fix breadcrumb */
    let breadCrumbNode1 = {
      breadcrumbName: currentModel,
      url: `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}`,
      callback: () => {
        onRouteChanged({
          model: match.params.model,
          category: undefined,
          topic: undefined
        });
        scrollToTop();
      }
    };
    let breadCrumbNode2 = {
      breadcrumbName: activeCategory?.title,
      url: `/${match.params.lang}/${match.params.sitecoreRoute}/----${match.params.model}/${category}`,
      callback: () => {
        onRouteChanged({
          model: match.params.model,
          category: category,
          topic: undefined
        });
        scrollToTop();
      }
    };
    let breadCrumbNode3 = {
      breadcrumbName: activeTopic?.title
    };
    setDynamicBreadcrumbList([breadCrumbNode1, breadCrumbNode2, breadCrumbNode3]);
    scrollToTop();
  }, [activeCategory, activeTopic]);
  const topicArticleRouteChanged = params => {
    onRouteChanged({ params });
  };
  return (
    <>
      {activeTopic && (
        <div className="topic-page grid">
          <div className="topic-page-header grid">
            {fields.articleOverline.value && <p className="overline">{fields.articleOverline.value}</p>}

            <Heading
              {...{
                html: { value: `<span>${activeTopic.title}</span>` },
                type: { fields: { phrase: { value: "h1" } } },
                typographyClass: "type-h1"
              }}
            />

            {fields.articleBackCTALabel.value && <IconLink {...backCTA} />}
          </div>
          <TopicArticle fileName={activeTopic.content} match={match} fields={fields} history={history} title={activeTopic.title} onRouteChanged={topicArticleRouteChanged} />
        </div>
      )}
    </>
  );
};
const ImageSlider = ({ htmlCollection }) => {
  var imageList = Array.from(htmlCollection);
  return (
    <Carousel showThumbs={false} infiniteLoop={false}>
      {imageList.map((item, index) => {
        return (
          <div key={`carousel-item-${index}`}>
            <img src={item.attributes.src.value} alt={item.attributes.alt.value} />
          </div>
        );
      })}
    </Carousel>
  );
};
const TopicArticle = ({ fileName, fields, title, history, onRouteChanged, match }) => {
  const [content, setContent] = useState("");
  const [data, setData] = useState(null);
  const { scrollToTop, getBaseURL } = useContext(UserManualContext);
  const [imageArray, setImageArray] = useState([]);
  const baseURL = getBaseURL(match?.params?.model)?.replace("/manifest.json", "");

  const generateVideo = source => {
    return `<video
    controls
      muted
      autoplay
      loop
      playsinline
    >
      <source src="${source}" type="video/mp4" />
    </video>`;
  };

  useEffect(() => {
    if (!canUseDOM()) {
      return;
    }

    const getContent = async () => {
      const res = await fetch(`${baseURL}/${fileName}`);
      const data = await res.text();
      const markup = data.replace(/asset-/g, `${baseURL}/asset-`);
      const dom = parseXml(markup);
      const json = xml2json(dom);
      const jsonObject = JSON.parse(json.replace("undefined", ""));
      setData({ ...jsonObject, title: title });
      setContent(markup);
    };

    getContent();
    scrollToTop();
  }, [fileName]);

  useEffect(() => {
    if (!canUseDOM()) {
      return;
    }

    if (content) {
      try {
        const warnings = document.querySelectorAll(".warning");
        const elem = document.querySelector(".warningadmonitions");

        if (elem) {
          const count = document.createElement("div");
          count.className = "warnings";
          count.innerText = `${fields.warningsLabel?.value || ""} (${warnings.length})`;
          elem.prepend(count);
          elem.classList.add("admotions");
          elem.addEventListener("click", () => {
            elem.classList.toggle("active");
          });
        }
      } catch (error) {
        console.error(error);
      }

      try {
        const cautions = document.querySelectorAll(".caution");
        const elem = document.querySelector(".cautionadmonitions");

        if (elem) {
          const count = document.createElement("div");
          count.className = "cautions";
          count.innerText = `${fields.cautionLabel?.value || ""} (${cautions.length})`;
          elem.prepend(count);
          elem.classList.add("admotions");
          elem.addEventListener("click", () => {
            elem.classList.toggle("active");
          });
        }
      } catch (error) {
        console.error(error);
      }

      try {
        const notices = document.querySelectorAll(".notice");
        const elem = document.querySelector(".noticeadmonitions");

        if (elem) {
          const count = document.createElement("div");
          count.className = "notices";
          count.innerText = `${fields.noticeLabel?.value || ""} (${notices.length})`;
          elem.prepend(count);
          elem.classList.add("admotions");
          elem.addEventListener("click", () => {
            elem.classList.toggle("active");
          });
        }
      } catch (error) {
        console.error(error);
      }

      try {
        // related articles text
        const relatedArticlesDOMNodes = document.querySelectorAll(".explore");
        relatedArticlesDOMNodes.forEach(item => {
          item.setAttribute("data-content", fields.relatedArticlesLabel?.value || "");
        });

        // related articles links
        const exploreLinks = document.querySelectorAll(".explore > p");
        exploreLinks.forEach(link => {
          link.insertAdjacentHTML("afterbegin", fields.relatedArticlesIcon?.value?.alt);
        });

        // hide empty grey box
        const infoBox = document.querySelector(".info");
        if (infoBox && !infoBox.hasChildNodes()) {
          infoBox.style.display = "none";
        }

        // fix counting in numbered lists
        const ol = document.querySelectorAll("ol[start]");
        const parent = document.querySelector("ol") ? document.querySelector("ol").parentElement : undefined;
        if (parent) {
          if (ol?.length > 0) {
            parent.style.counterReset = "li";
          } else {
            parent.style.counterReset = "none";
          }
        }

        // video fix
        const playVideo = document.querySelectorAll(".imageleft > p > video");
        playVideo.forEach(item => {
          let parent = item.parentNode;
          let videoNode = generateVideo(item.src);

          parent.removeChild(item);
          parent.innerHTML = videoNode;
        });
        // image slider fix
        const imageContainer = document.querySelector(".imageleft > p");
        const imageList = imageContainer.children;
        const oldImageNode = document.querySelector(".imageleft");
        const imageSlider = document.querySelector(".imageSlider");

        if (imageList.length > 1) {
          document.querySelector(".imageleft").style.display = "none";
          setImageArray(imageList);
          oldImageNode.insertAdjacentElement("beforebegin", imageSlider);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [content]);

  const serverError = fields.error
    ? {
        heading: fields.error.fields.heading.value,
        subheading: fields.error.fields.subheading.value,
        infoMessage: {
          html: fields.error.fields.infoMessage.value
        },
        showIcon: fields.error.fields.showIcon.value,
        linkRetry: fields.error.fields?.linkRetry
          ? {
              buttonText: fields.error.fields?.linkRetry.fields.buttonText.value,
              callback: () => {
                window.location.reload();
              }
            }
          : null,
        linkAway: fields.error.fields.link ? fields.error.fields.link.fields : null
      }
    : undefined;

  let structuredData = null;
  try {
    structuredData = fields.topicArticleMapping.value && data ? transform(data, JSON.parse(fields.topicArticleMapping.value)) : null;
  } catch (error) {
    console.error("json-path-transform error", error);
  }
  let statusCode;
  try {
    statusCode = JSON.parse(content.toString()).status_code;
  } catch (error) {}

  if (content && statusCode === 404) {
    return (
      <div className="content">
        <ServerError {...serverError} />
      </div>
    );
  }
  return (
    <>
      {structuredData && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </Helmet>
      )}

      <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
      <div className="imageSlider">
        <ImageSlider htmlCollection={imageArray}></ImageSlider>
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  setDynamicBreadcrumbList: breadcrumbList => dispatch(setDynamicBreadcrumbList(breadcrumbList)),
  dispatch
});

export default withRouter(connect(null, mapDispatchToProps)(UserManual));

UserManual.propTypes = {
  tabMenu: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.object),
  componentPadding: PropTypes.object
};
